module.exports = __webpack_public_path__ + "static/media/asset4.e9e1e54d.png";